import { generateTestId } from "@client-shared";
import type { ShippingDocumentsTabType } from "@shared/types";

export const setShippingDocumentsDialogTestId = (identifier: string): string => generateTestId("ShippingDocumentsDialog", identifier);

export const SHIPPING_DOCUMENTS_SECTIONS = {
  root: "root",
  tabs: "tabs",
  pdfFrame: "pdfFrame",
  loadingContainer: "loadingContainer",
  errorAlert: "errorAlert",
  previewFallback: "previewFallback",
  paperSizeGroup: "paperSizeGroup",
  groupByGroup: "groupByGroup",
  downloadButton: "downloadButton",
  cancelButton: "cancelButton",
} as const;

export const getLoadingMessageKey = (isLargeDataset: boolean, activeTab: ShippingDocumentsTabType): string => {
  if (isLargeDataset) {
    return "components.ShippingDocumentsDialog.generatingPDFLargeDataset";
  }
  if (activeTab === "manifest") {
    return "components.ShippingDocumentsDialog.preparingManifest";
  }
  return "components.ShippingDocumentsDialog.generatingPDF";
};
